import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { VerifyCodeApi } from "../APIs/API";
import { MyContext } from "../MyContext/MyProvider";

const Verifycode = () => {
  const navigate = useNavigate();
  const [code, setCode] = useState(["", "", "", ""]);
  const { setIsLoading } = useContext(MyContext);


  const handleChange = (e, index) => {
    const { value } = e.target;
    if (/^\d$/.test(value)) {
      const newCode = [...code];
      newCode[index] = value;
      setCode(newCode);
      if (index < 3) {
        document.getElementById(`code-input-${index + 1}`).focus();
      }
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      const newCode = [...code];
      newCode[index] = "";
      setCode(newCode);
      if (index > 0) {
        document.getElementById(`code-input-${index - 1}`).focus();
      }
    }
  };
  const onSubmit = async (e) => {
    setIsLoading(true)
    e.preventDefault();
    let otp = "";
    code.forEach((char) => {
      otp = otp.concat(char);
    });
    const data = { code: otp };
    try {
      const res = await VerifyCodeApi(data);
      // console.log(res);
      res && navigate("/resetpassword", { state: { code: otp } });
    } catch (error) {
      console.log(error);
    }
    finally{
      setIsLoading(false)
    }
  };

  return (
    <div className="login-main-container h-center v-center ">
      <div className="login-container w-100 verify-con">
        <div className="input-form-main ">
          <h3 className="text-medium-black ">Verify Code</h3>
          <form
            className="input-form h-center flex-column forgetpswd"
            onSubmit={onSubmit}
          >
            <div className="verification-code-div h-center">
              {code.map((digit, index) => (
                <input
                  key={index}
                  id={`code-input-${index}`}
                  name="code"
                  className="code-input"
                  value={digit}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  maxLength="1"
                  required
                />
              ))}
            </div>
            <div className="bottom-btn-div mt-5 pt-1">
              <button className="btn-primary" type="submit">
                Verify Code
              </button>
              <div className="mt-3">
                <label className="small fw-normal h-center v-center gap-1 text-black montserrat-family">
                  Didn’t receive code!
                  <Link to="/forgetpassword">
                    <label className=" text-red link text-underline montserrat-family">
                      Send Again
                    </label>
                  </Link>
                </label>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Verifycode;
